// readLatest — the read behind a form's Load the latest (ADR-084 §6): the row's read made OUTSIDE the cache, written
// into the page's entry only once it answers. The page behind refreshes with the form; a failed read (a row gone
// — 404, retried; a busy answer; a 5xx) never puts the page's own query in error, which would swap the page for
// its error state and unmount the form with the typing. A row with a detail read hands that read (quiet — a row
// gone answers the form, never the not-found page). A row seeded from a WHOLE list (no detail read — the list is
// the row's read) rides readLatestRow: the list re-read, its row picked by id, the list written in only while it
// still holds the row — a row gone leaves the page as it was until the form closes (a page that draws the form
// from that list would otherwise drop it, the typing with it, before the form can say the row is gone).

import type { QueryClient, QueryKey } from '@tanstack/react-query';

export async function readLatest<T>(qc: QueryClient, queryKey: QueryKey, read: () => Promise<T>): Promise<T> {
  const fresh = await read();
  qc.setQueryData(queryKey, fresh);
  return fresh;
}

export async function readLatestRow<TList, TRow>(
  qc: QueryClient,
  queryKey: QueryKey,
  read: () => Promise<TList>,
  pick: (list: TList) => TRow | undefined,
): Promise<TRow | null> {
  const fresh = await read();
  const row = pick(fresh);
  if (row === undefined) return null;
  qc.setQueryData(queryKey, fresh);
  return row;
}
